/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice } from "@reduxjs/toolkit";
import { getSpecificTransactionLog } from "../actions/transactionLogs.action";

const initialState: any = {
  isLoading: false,
  data: {
    body: [],
  },
};

const getSpecificTransactionLogSlice = createSlice({
  name: "Get Specific Transaction Log",
  initialState,
  reducers: {
    resetSpecificTransactionData: (state) => {
      state.isLoading = initialState.isLoading;
      state.data.body = initialState.data.body;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getSpecificTransactionLog.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(getSpecificTransactionLog.fulfilled, (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    });

    builder.addCase(getSpecificTransactionLog.rejected, (state) => {
      state.isLoading = false;
    });
  },
});
export const { resetSpecificTransactionData } = getSpecificTransactionLogSlice.actions;
export default getSpecificTransactionLogSlice.reducer;
